<template>
    <b-modal
        id="roadmap-step-title-edit-modal"
        v-model="modal"
        :title="stepIn.title === null ? 'Titel aanpassen' : 'Titel aanpassen'"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="!title"
        size="md"
        @ok="onOk()"
        modal-class="apprentice-default-modal">
        <div class="update-roadmap-title">
            <b-form-group
                :label="$t('common.cancel')"
                label-for="roadmap-title-input">
                <b-form-input
                    id="roadmap-title-input"
                    v-model="title"
                    :placeholder="$t('roadmap.type_title_here')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-roadmap-step-edit-title-modal-component',
    props: ['stepIn'],
    data() {
        return {
            title: this.stepIn.title ? this.stepIn.title : '',
            modal: false,
        };
    },
    methods: {
        show() {
            this.modal = true;
            this.title = this.stepIn.title ? this.stepIn.title : '';
        },

        onOk() {
            this.alert.saving();

            const data = {
                id: this.stepIn.id,
                title: this.title,
            };

            this.axios.post(this.routes.roadmapStepTitle(), data).then(
                (response) => {
                    this.stepIn.update({ title: this.title });

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style></style>
